/* eslint-disable @typescript-eslint/no-explicit-any */
// This should not be considered safe for api calls generally - use locally only

import { AnyObject, PrettifyObject } from 'types';

export function getID(): string {
  if (window?.crypto?.randomUUID) return window.crypto.randomUUID();

  // Fallback using Math.random() - not cryptographically secure!
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8;

    return v.toString(16);
  });
}

type WithID<E> = PrettifyObject<E & { id: string }>;

/**
 * Generate an ID for an object/array of object
 *
 * Does not overwrite if existing ID prop is found
 */
export function withId<E extends AnyObject | AnyObject[]>(
  target: E,
): E extends Array<any> ? WithID<E[number]>[] : WithID<E> {
  const x = Array.isArray(target)
    ? target.map((t) => ({ id: getID(), ...t }))
    : { id: getID(), ...target };

  return x as E extends Array<any> ? WithID<E[number]>[] : WithID<E>;
}

export function randomNum() {
  const [, int] = String(Math.random()).split('.');

  return int;
}
